import { Badge } from '@atlas/ui-primitives'
import { NavBadge } from '@/config/nav'
import { useWorkfrontOverview } from '@/hooks/useWorkfront'

/** Open error-level problems across the adapter's steps; warnings do not count. */
function useWorkfrontOpenErrors(): number {
	const overview = useWorkfrontOverview()
	return Object.values(overview.data?.openErrorsByStep ?? {}).reduce((sum, counts) => sum + counts.error, 0)
}

const COUNTS: Record<NavBadge, () => number> = {
	[NavBadge.WORKFRONT_OPEN_ERRORS]: useWorkfrontOpenErrors,
}

/**
 * The live count beside a nav entry, or nothing when it is zero. Rendered only for
 * entries the user's role already shows, so it never fetches what they may not read.
 */
export function NavBadgeCount({ badge }: { badge: NavBadge }) {
	const count = COUNTS[badge]()
	if (count === 0) return null
	return (
		<Badge size="sm" variant="danger" aria-label={`${count} open`}>
			{count}
		</Badge>
	)
}
